// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"6b7d4f37","193":"444a7a2b","225":"36210441","246":"40ac82d1","264":"63d51803","426":"75e3e8b3","643":"4cb6df6e","697":"b170b6eb","771":"34ebe7ed","823":"2f324986","957":"2dd7d016","966":"08648b41","972":"dfc5bcea","981":"2ec95369"}[chunkId] + ".chunk.js";
};